import { assetRegistry } from '../lib/assets/registry';

type Props = { className?: string };

export function BrandLogo({ className = 'brand-logo' }: Props) {
  return <img className={className} src={assetRegistry.brand.logoPrimary} alt="BelajarKu" />;
}
